import React from 'react';
import { FormattedMessage } from 'react-intl';

import { H, P } from '@xingternal/malt-typography';

import IllustrationPlaceholder from './../../Components/Illustrations/IllustrationPlaceholder';
import ResendCountdown from './../../Components/ResendCountdown/ResendCountdown';
import Spacer from './../../Components/Spacer/Spacer';
import PageviewTracker from './../../Components/PageviewTracker/PageviewTracker';
import withActionTracker from './../../Components/PageviewTracker/withActionTracker';

import messages from './messages';
import styles from './LoginKnownUser.css';

const LoginOneTimeLinkConfirm = ({ knownUser: { email }, track }) => (
  <>
    <PageviewTracker pageName={'wbm/Welcome/login/magic_link_sent'} />
    <IllustrationPlaceholder />

    <H>
      <FormattedMessage {...messages.oneTimeLinkSuccessHeadline} />
    </H>

    <P>
      <FormattedMessage
        {...messages.oneTimeLinkSuccessParagraphWithEmail}
        values={{ email: <strong>{email}</strong> }}
      />
    </P>

    <P>
      <FormattedMessage {...messages.oneTimeLinkSuccessParagraph} />
    </P>

    <Spacer size={4} />

    <ResendCountdown
      isLink
      resendEndpoint={'/login/one_time_login_link'}
      onSuccess={() => track('welcome_login_magic_link_resend_click')}
    />

    <Spacer size={12} />

    <P level={3} className={styles.weakCopy}>
      <FormattedMessage {...messages.oneTimeLinkSuccessFootnote} />
    </P>
  </>
);

export default withActionTracker(LoginOneTimeLinkConfirm);
